import React from "react";

function HomeDashboardCards({label = '', count = 0, icon = <></>, iconColor = '', index = 0, onClick}) {
  const countinObject = typeof count === 'object';
  const isBillingCard = label === "Billing";

  return (
    <div
      key={index}
      className={`flex flex-col p-4 m-1 bg-[rgb(255,255,255)] shadow-md rounded-lg w-[32%] ${onClick ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''}`}
      onClick={onClick ? onClick : undefined}
    >
      <div className="flex justify-between">
        <span className="text-xl font-bold">{label}</span>
        <div className={`bg-[${iconColor}]`}>{icon}</div>
      </div>
      <div className={`flex ${countinObject || isBillingCard ? "justify-between" : "justify-end h-full"} pt-4`}>
        {isBillingCard && (
          <div className="flex flex-col gap-1">
            <span className="text-base text-gray-600">USD Amount: $2,000</span>
            <span className="text-base text-gray-600">INR Amount: ₹5,00,000</span>
          </div>
        )}
      {countinObject && label === "AI Mock Interviews" && (
          <div className="flex flex-col">
            <span>Paid Mock Interviews Purchased: {count.mock_interview_credits_buy}</span>
            <span>Free Mock Interviews: {count.freeTrial}</span>
          </div>
        )}
        {countinObject && label !== "AI Mock Interviews" && !isBillingCard && 
        <div className="flex flex-col">
          {count?.mock_interview_credits != null && <span>Credit Purchased: {count?.mock_interview_credits}</span>}
          {count?.totalInterviewCount != null && <span>Used Credits: {count?.totalInterviewCount}</span>}
          {count?.Working_With_Vendors && <span>Working With Vendor: {count?.Working_With_Vendors}</span>}
          {count?.OPEN && <span>Open: {count?.OPEN}</span>}
          {count?.Open_Resources || count?.Published_Resources ? <span className="font-bold pt-1">Marketplace</span> : <></>}
          {count?.Open_Resources && <span className="pl-2"> - Open Resource: {count?.Open_Resources}</span>}
          {count?.Published_Resources && <span className="pl-2"> - Published Resource: {count?.Published_Resources}</span>}
        </div>}
        <div className={`flex flex-col justify-end items-end h-full ${countinObject || isBillingCard ? "" : "pr-1 pt-2" }`}>
          <span className="text-4xl font-bold">
            {isBillingCard ? ("") : label === "AI Mock Interviews" && countinObject ? (
              count.mock_interview_credits_buy + count.freeTrial 
            ) : countinObject ? (
              count?.Working_With_Vendors || count?.Open_Resources || count?.Published_Resources 
                  ? (count?.Working_With_Vendors + count?.Open_Resources + count?.Published_Resources) 
                  : count?.OPEN || count?.CLOSED || count?.HIRED && 
                    <span className="text-4xl font-bold">{count?.OPEN + count?.CLOSED + count?.HIRED}</span>
            ) : (
                count
            )}
          </span>
        </div>
      </div>
    </div>
  );
}

export default HomeDashboardCards;